import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import 'ckeditor5/ckeditor5.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./assets/styles/scss/main.scss";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext"; // ✅ Ensure the correct path

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter basename="/fanhub">
    <AuthProvider> {/* ✅ Wrap with AuthProvider to provide authentication */}
      <App />
    </AuthProvider>
  </BrowserRouter>
);

reportWebVitals();



